import { MainLayout } from '../../design-system/Templates';
import { Footer } from '@/design-system/Organisms';
import { HealthQuestionnairesTemplate } from '@/design-system/Templates';

const HealthQuestionnaires = () => {

    return (
        <MainLayout
            header={null}
            sidebar={null}
            className=""
            footer={<Footer config={{ showTopSection: false }} />}
            topBanner={null}
        >
            <HealthQuestionnairesTemplate />
        </MainLayout >
    );
};

export default HealthQuestionnaires;
